export const LANGUAGES = [
  {
    text: 'English',
    value: 'en',
  },
  {
    text: 'Pусский',
    value: 'ru',
  },
  {
    text: '日本語',
    value: 'ja',
  },
  {
    text: '한국어',
    value: 'ko',
  },
  {
    text: 'Español',
    value: 'es',
  },
  {
    text: 'Deutsch',
    value: 'de',
  },
  {
    text: 'Français',
    value: 'fr',
  },
  {
    text: 'Türkçe',
    value: 'tr',
  },
  {
    text: 'Português',
    value: 'pt',
  },
  {
    text: 'tiếng Việt',
    value: 'vi',
  },
];

export const DISABLE_LANGS = ['cn'];
